// extracted by mini-css-extract-plugin
export default {"mainCont":"PDRemove_mainCont__GnNCu","title":"PDRemove_title__SiVRC","agCont":"PDRemove_agCont__hxXgW","btnCont":"PDRemove_btnCont__gEqq3","agree":"PDRemove_agree__6LG+x"};